import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { cardsStore } from '../../store/cardsStore';
import { CARDS_BOX, CARDS_TYPE, HORIZONTAL_CARDS_INDEX } from '../../enums/cardTypes';
import { IDS } from '../../enums/constants';
import { ROUND_WIN_TYPE } from '../../enums/betTypesEnum';

export const PlayerCardsBox = observer(() => {
  const { playerCards, playerTotalPoints, selectedCardType } = cardsStore;
  const t = useTranslation();

  return (
    <div className='table-cards-box'>
      <div className='table-cards-cl left-cl'>
        {CARDS_BOX.map((item, index) => {
          const card = playerCards.length > index ? playerCards[index] : null;
          return (
            <div
              className={`cards ${index === HORIZONTAL_CARDS_INDEX ? 'horizontal' : ''}`}
              key={IDS[index]}
            >
              {card && (
                <div className={`card-holder ${CARDS_TYPE[card.card]} ${selectedCardType}`}>
                  <div className='card-holder-inner' />
                </div>
              )}
            </div>
          );
        })}
        {playerTotalPoints !== null && playerCards.length ? (
          <span className='bottom-card-number'>{playerTotalPoints}</span>
        ) : null}
      </div>
      <p className='cards-player-text left-text'>{t(ROUND_WIN_TYPE['1'])}</p>
    </div>
  );
});
